// extracted by mini-css-extract-plugin
export default {"productCarousel":"A4-z"};